module.exports = __webpack_public_path__ + "static/cosmicguard.com/img/ico-settings.65f408f3.png";